import { createIcon } from '@chakra-ui/react'

export const SwapIcon = createIcon({
  displayName: 'Swap',
  path: (
    <g>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M21 1C21.5523 1 22 1.44772 22 2V8C22 8.55228 21.5523 9 21 9H15C14.4477 9 14 8.55228 14 8C14 7.44772 14.4477 7 15 7H20V2C20 1.44772 20.4477 1 21 1Z'
        fill='currentColor'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M13.2337 4.10389C11.7084 3.86584 10.1468 4.07417 8.73734 4.70374C7.32784 5.33332 6.13059 6.35726 5.29 7.65205C4.44942 8.94685 4.00141 10.4572 4 12.0009C3.9995 12.5532 3.55137 13.0005 2.99909 13C2.4468 12.9995 1.9995 12.5514 2 11.9991C2.00176 10.0694 2.56178 8.18151 3.61251 6.56302C4.66324 4.94453 6.1598 3.6646 7.92168 2.87763C9.68356 2.09066 11.6355 1.83025 13.5421 2.12781C15.4486 2.42538 17.2284 3.26821 18.6667 4.55464L18.669 4.5567L21.669 7.25671C22.0795 7.62616 22.1128 8.25845 21.7433 8.66896C21.3738 9.07947 20.7415 9.11275 20.331 8.74329L17.3333 6.04536L17.3322 6.04437C16.1818 5.01578 14.7584 4.34187 13.2337 4.10389Z'
        fill='currentColor'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M2.00001 16C2.00001 15.4477 2.44772 15 3.00001 15H9.00001C9.55229 15 10 15.4477 10 16C10 16.5523 9.55229 17 9.00001 17H4.00001V22C4.00001 22.5523 3.55229 23 3.00001 23C2.44772 23 2.00001 22.5523 2.00001 22V16Z'
        fill='currentColor'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M21.0009 11C21.5532 11.0005 22.0005 11.4486 22 12.0009C21.9983 13.9306 21.4382 15.8185 20.3875 17.437C19.3368 19.0555 17.8402 20.3354 16.0783 21.1224C14.3165 21.9093 12.3645 22.1698 10.4579 21.8722C8.55137 21.5746 6.77162 20.7318 5.33334 19.4454L5.33104 19.4433L2.33104 16.7433C1.92053 16.3738 1.88726 15.7415 2.25671 15.331C2.62617 14.9205 3.25846 14.8872 3.66897 15.2567L6.66668 17.9546L6.66781 17.9557C7.81823 18.9842 9.2416 19.6581 10.7664 19.8961C12.2916 20.1342 13.8532 19.9258 15.2627 19.2963C16.6722 18.6667 17.8694 17.6427 18.71 16.3479C19.5506 15.0532 19.9986 13.5428 20 11.9991C20.0005 11.4468 20.4486 10.9995 21.0009 11Z'
        fill='currentColor'
      />
    </g>
  ),
  viewBox: '0 0 24 24',
})
